import React, { useState } from 'react';
import WeeklyCalendar from '../components/WeeklyCalendar';
import FilmCard from '../components/FilmCard';
import '../styles/Cinemas.css';
import { Link } from 'react-router-dom';
import filmsData from "../data/movies.json";
import { motion } from "framer-motion";
import { slugify } from "../components/utils";

const groupByGenre = (films) => {
  const genreCount = {}; 
  const groupedFilms = {}; 
  const others = [];

  films.forEach(film => {
      film.genre.forEach(g => {
          if (!genreCount[g]) genreCount[g] = 0;
          genreCount[g]++; 
      });
  });

  films.forEach(film => {
      film.genre.forEach(g => {
          if (genreCount[g] >= 3) {
              if (!groupedFilms[g]) groupedFilms[g] = [];
              groupedFilms[g].push(film);
          } else {
              others.push(film);
          }
      });
  });

  if (others.length > 0) {
      groupedFilms["Autres genres"] = others;
  }

  return groupedFilms;
};

const Cinemas = () => {
    const [searchQuery, setSearchQuery] = useState('');
    const filteredFilms = filmsData.filter(film => 
        film.titre.toLowerCase().includes(searchQuery.toLowerCase())
    );

    // Trier les résultats pour mettre ceux qui correspondent en premier
    const sortedFilteredFilms = filteredFilms.sort((a, b) => {
        return a.titre.toLowerCase().indexOf(searchQuery.toLowerCase()) - 
               b.titre.toLowerCase().indexOf(searchQuery.toLowerCase());
    });

    const filmsByGenre = searchQuery ? { "Résultats de recherche": sortedFilteredFilms } : groupByGenre(filmsData);
    
    return (
        <div className="cinema-page">
            <h1 className="text-3xl font-bold mb-8">Films du moment</h1>
            {/* Barre de recherche */}
            <div className="search-container">
                <input
                    type="text"
                    placeholder="Rechercher un film par titre..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="search-input"
                />
            </div>
            
            {/* Section Calendrier avec filtre par recherche */}
            <div className="calendar-section mb-12 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl p-6 shadow-lg">
                <h2 className="text-2xl font-semibold mb-6 text-gray-800">Agenda des sorties</h2>
                <WeeklyCalendar films={filmsData} />
                
            </div>

            {/* Section Films */}
            <div className="films-container">
                {Object.entries(filmsByGenre).length > 0 ? (
                    Object.entries(filmsByGenre).map(([genre, films]) => (
                        <div key={genre} className="genre-section">
                            <h2 className="genre-title">{genre}</h2>
                            <div className="films-slider">
                                {films.map((film) => (
                                    <motion.div
                                        key={film.id}
                                        className="slider-item"
                                        whileHover={{ scale: 1.02 }}
                                    >
                                        <Link to={`/film/${slugify(film.titre)}`}>
                                            <FilmCard film={film} />
                                        </Link>
                                    </motion.div>
                                ))}
                            </div>
                        </div>
                    ))
                ) : (
                    <p className="no-results">Aucun film ne correspond à votre recherche.</p>
                )}
            </div>
        </div>
    );
};
export default Cinemas;
